var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('login-form',{staticClass:"login-form",attrs:{"redirect":"/home","locale-selectable":true,"show-logo":true,"logo":"vue-crud-lg.png"}})}
var staticRenderFns = []

export { render, staticRenderFns }